import { links, mixpanel, constants } from 'common/helpers'

import aboutMessages from './about/messages'
import shopMessages from './shop/messages'


const defaultData = {
  about: {
    title: aboutMessages.title,
    nav: [
      { title: aboutMessages.aboutUs, to: links.team },
      {
        title: aboutMessages.faq,
        redirect: links.faq,
        onClick: () => mixpanel.track(constants.analyticsEvents.faqLinkClick, { placement: 'footer' }),
      },
      { title: aboutMessages.bloggerProgram, to: links.blogger },
      // { title: aboutMessages.affiliateProgram, toOLD: links.affiliateProgram },
      { title: aboutMessages.forPress, to: links.press },
      {
        title: aboutMessages.blog,
        toOLD: `${links.blog}/`,
        onClick: () => mixpanel.track(constants.analyticsEvents.blog, { placement: 'footer' }),
      },
      { title: aboutMessages.contactUs, redirect: 'https://scentbird.zendesk.com/hc/en-us/requests/new' },
      { title: aboutMessages.careers, to: links.careers },
      { title: aboutMessages.reviews, to: links.scentbirdReviews },
    ],
  },
  shop: {
    title: shopMessages.title,
    nav: [
      { title: shopMessages.shop, to: links.subscription.smartSearch },
      { title: shopMessages.makeup, to: links.makeup },
    ],
  },
}


export default defaultData
